import { Lang } from 'enums';

type Message = {
  [lang: string]: string;
};

export const extractTranslationsFromJson = (locale: Lang) => (data: string) => {
  const response = Object.entries(JSON.parse(data));
  return response.reduce((accumulator, value) => {
    const [key, message] = value;
    return {
      ...accumulator,
      [key]: (message as Message)[locale.toUpperCase()],
    };
  }, {});
};
